import { render, staticRenderFns } from "./BitGoCustodialInput.vue?vue&type=template&id=50547907&"
import script from "./BitGoCustodialInput.vue?vue&type=script&lang=ts&"
export * from "./BitGoCustodialInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports